function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11C17.345 11 22 8.985 22 6.5C22 4.015 17.345 2 12 2C6.656 2 2 4.015 2 6.5C2 8.985 6.656 11 12 11ZM12 13C15.783 13 19.708 12.031 22 10.197V11.5C22 13.985 17.345 16 12 16C6.656 16 2 13.985 2 11.5V10.197C4.292 12.031 8.217 13 12 13ZM12 18C15.783 18 19.708 17.031 22 15.197V16.5C22 18.985 17.345 21 12 21C6.656 21 2 18.985 2 16.5V15.196C4.292 17.031 8.217 18 12 18Z",
  fill: "url(#paint0_linear_20013992_47871)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20013992_47871",
  x1: 22,
  y1: 29.5,
  x2: -2.19691,
  y2: 6.39531,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0D467A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71875,
  stopColor: "#9CC4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})));

function SvgAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmount);
export default __webpack_public_path__ + "static/media/amount.5bae338cdf5e3cc28a63b29041f2e019.svg";
export { ForwardRef as ReactComponent };